"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _buttonTypes = _interopRequireDefault(require("./button-types"));

var _default = _propTypes.default.shape({
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  type: _propTypes.default.oneOf(Object.values(_buttonTypes.default)),
  onClick: _propTypes.default.func.isRequired,
  isLoading: _propTypes.default.bool
});

exports.default = _default;